import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import {MatSort} from "@angular/material";
import {
  MatTableDataSource,
  MatPaginator,
  MatDatepickerInputEvent,
} from "@angular/material";
import { AppService } from "src/_services/app.service";
import { ActivatedRoute, Router } from "@angular/router";
import { GameReportBySport } from "src/_models";
import { Location } from "@angular/common";
import * as moment from "moment";

@Component({
  selector: "gm-report-provider-level",
  templateUrl: "./gr-provider-level.component.html",
  styleUrls: ["../game-report.component.scss"],
})
export class GrProviderLevelComponent implements OnInit, AfterViewInit {
  @ViewChild(MatSort) sort: MatSort;
  datalistDisplayedColumns: string[] = [
    "SportName",
    "TotalAmount",
    "TotalBets",
    "TotalCancel",
    "TotalCommission",
    "TotalLost",
    "TotalWon",
    "ToTalCashedOut",
    "CashedOutAmount",
    "TotalProfit",
  ];
  providers: any = [];
  selected: any = { startDate: 0, endDate: 0 };
  datalist = new MatTableDataSource<GameReportBySport>();
  filterUsers = [];
  users = [];
  providerId = "";
  operatorId = "";
  userID: string = "";
  origin = [];
  prTitle = "";
  category = "";
  subProvider = "";
  userName: string = "";
  startOfDay = moment().subtract(1, "days").startOf("day");
  endOfDay = moment().subtract(1, "days").endOf("day");
  ranges: any = {
    Today: [moment().startOf("day"), moment()],
    Yesterday: [
      moment(this.startOfDay),

      moment(this.endOfDay),
    ],
    "Last 7 Days": [
      moment(moment().subtract(6, "days").startOf("day")),
      moment(),
    ],
    "Last 30 Days": [
      moment(moment().subtract(29, "days").startOf("day")),
      moment(),
    ],
    "This Month": [moment().startOf("month"), moment()],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };
  constructor(
    private appService: AppService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private location: Location
  ) {}

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.providerId = params.providerId;
      this.userID = params.userId;
      this.operatorId = params.operatorId;
      this.userName = params.userName;
      this.origin = params["origin"];
      this.category = params["category"];
      this.subProvider = params["subProvider"];
      this.selected = {
        startDate:
          params.startTime !== "0"
            ? new Date(params.startTime * 1000)
            : new Date(),
        endDate:
          params.endTime !== "0" ? new Date(params.endTime * 1000) : new Date(),
      };

      if (this.providerId) {
        this.getReportData();
      }
    });
    let lowerCaseOrigins = this.origin.map(item => item.toLowerCase());
    this.prTitle = lowerCaseOrigins.length > 0 ? lowerCaseOrigins.join(', ') : "";
  }

  ngAfterViewInit() {
    this.datalist.sort = this.sort;
    this.datalist.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'SportName': return item.sportName;
        case 'TotalAmount': return item.totalAmount;
        case 'TotalBets': return item.totalBets;
        case 'TotalCommission':return item.totalCommission ;
        case 'TotalCancel':return item.totalCancel;
        case 'TotalLost':return item.totalLost;
        case 'TotalWon':return item.totalWon;
        case 'TotalProfit':return item.totalProfit;
        case 'ToTalCashedOut':return item.totalCashOut;
        case 'CashedOutAmount':return item.cashOutAmount;
        default: return item[property];
      }
    };
  }

  goBackGameReport = () => {
    this.router.navigate([`reports/game_report/`], {
      queryParams: {
        providerId: this.providerId,
        origin: this.origin ? this.origin : [],
        userId: this.userID ? this.userID : "",
        userName: this.userName ? this.userName : "",
        category: this.category ? this.category : "",
        subProvider : this.subProvider ? this.subProvider : "",
        startTime:
          this.selected.startDate !== null
            ?  Math.floor(new Date(this.selected.startDate).getTime() / 1000)
            : 0,
        endTime:
          this.selected.endDate !== null
            ?  Math.floor(new Date(this.selected.endDate).getTime() / 1000)
            : 0,
      },
    });
  };

  onDateChangeHandler = (event: MatDatepickerInputEvent<Date>) => {
    this.selected = event;
    if (this.selected.startDate !== null) {
      this.getReportData();
    }
  };

  getReportData = () => {
    try {
      let startDate, endDate;

      this.activatedRoute.queryParams.subscribe((params) => {
        (startDate = params.startTime), (endDate = params.endTime);
      });
      let filters = {
        userId: this.userID ? this.userID : null,
        providerId: this.providerId,
        origin: this.origin ? this.origin : [],
        category: this.category ? this.category : "",
        subProvider : this.subProvider ? this.subProvider : "",
        operatorId: this.operatorId,
        startTime:
          startDate === "0"
            ? 0
            : parseInt(
                (new Date(this.selected.startDate).getTime() / 1000).toFixed(0)
              ),
        endTime:
          endDate === "0"
            ? 0
            : parseInt(
                (new Date(this.selected.endDate).getTime() / 1000).toFixed(0)
              ),
      };
      this.appService.getGameReportByProvider(filters).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.datalist.data = res.sportGamesReports
        }
      });
    } catch (err) {}
  };

  goToSportLevel = (row: GameReportBySport) => {
    let startDate, endDate;

    this.activatedRoute.queryParams.subscribe((params) => {
      (startDate = params.startTime), (endDate = params.endTime);
    });

    this.router.navigate(
      [`reports/game_report/${this.providerId}/${row.sportId}`],
      {
        queryParams: {
          providerId: this.providerId,
          userId: this.userID ? this.userID : "",
          sportId: row.sportId,
          origin: this.origin ? this.origin : [],
          category: this.category ? this.category : "",
          subProvider : this.subProvider ? this.subProvider : "",
          sportName: row.sportName,
          userName: this.userName ? this.userName : "",
          operatorId: this.operatorId,
          startTime:
            startDate === "0"
              ? 0
              : parseInt(
                  (new Date(this.selected.startDate).getTime() / 1000).toFixed(
                    0
                  )
                ),
          endTime:
            endDate === "0"
              ? 0
              : parseInt(
                  (new Date(this.selected.endDate).getTime() / 1000).toFixed(0)
                ),
        },
      }
    );
  };
}
